export const categories = [
  {
    slug: "address-guide",
    name: "地址指南",
    icon: "ri-map-pin-line",
    description: "海角最新地址获取指南与使用教程",
    articleCount: 12,
  },
  {
    slug: "access-help",
    name: "访问帮助",
    icon: "ri-guide-line",
    description: "解决访问过程中遇到的各类问题",
    articleCount: 8,
  },
  {
    slug: "update-news",
    name: "更新动态",
    icon: "ri-newspaper-line",
    description: "海角平台最新更新与公告信息",
    articleCount: 15,
  },
  {
    slug: "faq",
    name: "常见问题",
    icon: "ri-question-answer-line",
    description: "海角地址使用中的常见问题解答",
    articleCount: 20,
  },
  {
    slug: "security-tips",
    name: "安全提示",
    icon: "ri-shield-check-line",
    description: "保障访问安全与隐私保护建议",
    articleCount: 6,
  },
];

export const articles = [
  {
    slug: "how-to-access-haijiao-latest",
    title: "如何正确访问海角最新地址 - 完整教程",
    category: "address-guide",
    excerpt: "本文将详细介绍如何正确访问海角最新地址，包括浏览器设置、网络配置以及常见问题的解决方法，帮助您顺利访问。",
    content: "<h2>一、访问前的准备工作</h2><p>在访问海角最新地址之前，建议您做好以下准备工作，以确保访问体验流畅稳定：</p><ul><li>确保使用最新版本的浏览器（推荐 Chrome、Firefox 或 Edge）</li><li>检查网络连接是否正常，建议使用稳定的宽带或移动网络</li><li>清除浏览器缓存和 Cookie，避免旧地址缓存导致访问异常</li><li>关闭不必要的浏览器插件，部分插件可能影响访问</li></ul><h2>二、获取最新地址的方法</h2><p>海角最新地址会定期更新，您可以通过以下方式获取最新的有效地址：</p><ol><li><strong>收藏本站：</strong>将本页面加入浏览器收藏夹，随时查看最新地址更新</li><li><strong>关注公告：</strong>留意本站发布的地址更新公告，第一时间获取新地址</li><li><strong>使用备用地址：</strong>当主地址无法访问时，可切换至备用地址</li></ol><h2>三、地址失效时的应对方案</h2><p>如果您发现当前使用的海角地址无法访问，请按照以下步骤操作：</p><ol><li>首先检查本页面显示的最新地址是否已更新</li><li>尝试使用备用地址列表中的其他地址</li><li>清除 DNS 缓存后重试（Windows：运行 ipconfig /flushdns）</li><li>如仍无法访问，请稍后再试或将网络切换至其他运营商</li></ol><h2>四、提升访问稳定性的建议</h2><p>为了获得更稳定的访问体验，我们建议：</p><ul><li>同时收藏主地址和备用地址，以备不时之需</li><li>定期访问本页面获取最新的地址更新信息</li><li>如遇到持续无法访问的情况，可联系客服获取帮助</li></ul>",
    author: "海角小编",
    publishedAt: "2026-08-06",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-access-guide-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-access-guide-01&orientation=landscape",
  },
  {
    slug: "haijiao-address-update-2026-08",
    title: "海角最新地址更新公告（2026年8月）",
    category: "update-news",
    excerpt: "2026年8月海角最新地址更新公告，包含新主入口地址、亚洲专线优化以及备用地址调整的详细信息。",
    content: "<h2>更新概览</h2><p>2026年8月，海角平台对全球访问节点进行了全面升级优化，以提供更稳定、更快速的访问体验。本次更新主要涉及以下内容：</p><h2>主入口地址更新</h2><p>新的主入口地址已部署上线，采用了全新的 CDN 加速架构，全球访问速度提升约 40%。请用户及时更新收藏夹中的地址。</p><h2>亚洲专线优化</h2><p>针对亚洲地区用户的访问需求，我们对亚洲专线节点进行了专项优化，新增了多个边缘节点，延迟降低约 30%。</p><h2>备用地址调整</h2><p>为提升容灾能力，备用地址池扩充至三个独立地址，分布在不同的服务区域，确保主地址出现异常时能够无缝切换。</p><h2>安全升级</h2><p>所有地址均启用了最新的 SSL/TLS 加密协议，保障用户数据传输安全。同时更新了防火墙规则，提升防护能力。</p>",
    author: "海角官方",
    publishedAt: "2026-08-01",
    readTime: "3分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-update-news-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-update-news-01&orientation=landscape",
  },
  {
    slug: "solve-address-failure",
    title: "海角地址失效？五种方法帮你快速解决",
    category: "access-help",
    excerpt: "遇到海角地址失效的情况不要着急，本文整理了五种经过验证的有效解决方法，帮你快速恢复访问。",
    content: "<h2>为什么海角地址会失效？</h2><p>地址失效是常见现象，可能由多种原因造成：DNS 污染、网络波动、服务器维护、地区限制等。了解原因有助于更好地应对。</p><h2>方法一：使用备用地址</h2><p>最直接有效的方法就是使用本站提供的备用地址。我们维护了多个备用地址，当主地址失效时可以立即切换。</p><h2>方法二：清除 DNS 缓存</h2><p>有时地址失效是由于本地 DNS 缓存过期导致的，清除 DNS 缓存后重试往往能解决问题。</p><h2>方法三：更换 DNS 服务器</h2><p>将 DNS 服务器更换为公共 DNS（如 8.8.8.8 或 1.1.1.1）可以绕过部分 DNS 污染问题。</p><h2>方法四：使用 VPN 或代理</h2><p>在某些地区，网络限制可能导致地址无法访问，使用 VPN 或代理服务可以有效解决此类问题。</p><h2>方法五：联系客服获取最新地址</h2><p>如果以上方法均无效，您可以直接联系我们的客服团队，获取最新的可用地址信息。</p>",
    author: "海角技术团队",
    publishedAt: "2026-08-05",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-access-help-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-access-help-01&orientation=landscape",
  },
  {
    slug: "haijiao-security-guide",
    title: "海角访问安全指南 - 保护您的隐私与数据",
    category: "security-tips",
    excerpt: "在访问海角地址时如何保护个人隐私与数据安全的完整指南，包括加密连接、防钓鱼和账户安全建议。",
    content: "<h2>为什么访问安全很重要？</h2><p>随着网络安全威胁日益增多，在访问任何在线平台时都应注意保护个人隐私和数据安全。以下是我们为您整理的安全指南。</p><h2>确认官方地址</h2><p>请务必通过本站获取海角官方地址，不要轻信搜索引擎或社交媒体上未经核实的地址链接，以防钓鱼网站。</p><h2>使用 HTTPS 加密连接</h2><p>所有海角官方地址均采用 HTTPS 加密协议，确保您的数据传输安全。访问时请确认地址栏显示安全锁图标。</p><h2>定期更新密码</h2><p>建议定期更换您的账户密码，使用包含大小写字母、数字和特殊字符的强密码，避免与其他平台共用密码。</p><h2>警惕钓鱼攻击</h2><p>请勿点击来路不明的邮件或消息中的链接，钓鱼者可能会伪装成海角官方发送虚假地址链接。</p>",
    author: "海角安全团队",
    publishedAt: "2026-07-28",
    readTime: "4分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-security-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-security-01&orientation=landscape",
  },
  {
    slug: "haijiao-faq-common-questions",
    title: "海角地址常见问题解答（FAQ）",
    category: "faq",
    excerpt: "整理了用户关于海角地址最常遇到的问题及详细解答，包括地址获取、访问异常、更新频率等热门问题。",
    content: "<h2>Q1：海角地址多久更新一次？</h2><p>海角地址的更新频率并不固定，通常在地址出现访问异常或需要进行节点优化时会发布更新。我们建议您定期访问本站以获取最新信息。</p><h2>Q2：为什么我收藏的地址突然打不开了？</h2><p>这通常是因为原地址的服务器进行了迁移或维护。建议您访问本站获取最新地址，并同时收藏备用地址以防万一。</p><h2>Q3：使用海角地址需要特殊工具吗？</h2><p>正常情况下无需特殊工具即可访问。但如果您所在地区网络限制较严格，可能需要借助代理或 VPN 服务。</p><h2>Q4：如何判断一个地址是否为官方地址？</h2><p>请以本站公布的地址为准，本站所有地址均经过官方认证。非本站公布的地址可能存在安全风险。</p><h2>Q5：多个地址之间有什么区别？</h2><p>不同地址对应不同的服务器节点和区域优化，您可以根据所在地区选择最佳的访问入口，以获得更快的速度。</p>",
    author: "海角客服",
    publishedAt: "2026-08-03",
    readTime: "4分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-faq-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-faq-01&orientation=landscape",
  },
  {
    slug: "haijiao-mobile-access-tutorial",
    title: "手机端访问海角最新地址教程",
    category: "address-guide",
    excerpt: "详细介绍在手机端（iOS 和 Android）如何快速访问海角最新地址，包括浏览器选择和设置优化。",
    content: "<h2>手机端访问概述</h2><p>越来越多的用户选择在手机端访问海角平台。本教程将详细介绍在 iOS 和 Android 设备上的最佳访问方法。</p><h2>iOS 设备访问指南</h2><p>iPhone 和 iPad 用户建议使用 Safari 或 Chrome 浏览器。在地址栏输入海角最新地址即可访问。建议允许跨站跟踪以获得更好的兼容性。</p><h2>Android 设备访问指南</h2><p>Android 用户推荐使用 Chrome 浏览器。如遇到访问问题，可尝试在设置中清除浏览数据后重试。</p><h2>手机网络优化建议</h2><p>使用 Wi-Fi 网络通常比移动数据更稳定。如果移动数据访问异常，可尝试切换至 Wi-Fi 或使用不同的运营商网络。</p>",
    author: "海角小编",
    publishedAt: "2026-08-04",
    readTime: "3分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-mobile-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-mobile-01&orientation=landscape",
  },
  {
    slug: "haijiao-dns-optimization",
    title: "DNS 优化设置 - 让海角地址访问更稳定",
    category: "access-help",
    excerpt: "通过优化 DNS 设置来提升海角地址的访问稳定性和速度，适用于 Windows、macOS、iOS 和 Android 各平台。",
    content: "<h2>什么是 DNS 优化？</h2><p>DNS（域名系统）是将域名转换为 IP 地址的服务。优化 DNS 设置可以加快域名解析速度，提升访问稳定性。</p><h2>推荐公共 DNS 服务器</h2><p>以下是经过测试对海角地址解析效果较好的公共 DNS：Google DNS (8.8.8.8)、Cloudflare DNS (1.1.1.1)。</p><h2>Windows 系统设置方法</h2><p>打开网络设置 → 更改适配器选项 → 右键当前网络 → 属性 → Internet 协议版本 4 → 使用下面的 DNS 服务器地址。</p><h2>macOS 系统设置方法</h2><p>系统偏好设置 → 网络 → 高级 → DNS → 添加 DNS 服务器地址。</p><h2>移动端设置方法</h2><p>iOS：设置 → 无线局域网 → 点击当前 Wi-Fi 旁的 (i) → 配置 DNS → 手动。Android：设置 → WLAN → 长按当前网络 → 修改网络 → 高级选项。</p>",
    author: "海角技术团队",
    publishedAt: "2026-07-30",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-dns-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-dns-01&orientation=landscape",
  },
  {
    slug: "haijiao-platform-introduction",
    title: "海角平台简介 - 了解海角的功能与特色",
    category: "address-guide",
    excerpt: "全面介绍海角平台的功能特色、核心优势以及发展历程，帮助新用户快速了解海角平台的价值。",
    content: "<h2>海角平台概述</h2><p>海角是一个集资讯、社区和内容于一体的综合平台，致力于为用户提供优质的内容体验和便捷的访问服务。</p><h2>核心功能特色</h2><p>海角平台拥有丰富的内容资源、活跃的用户社区、智能推荐系统和稳定的技术架构，为用户打造全方位的在线体验。</p><h2>发展历程</h2><p>海角平台自成立以来，不断优化技术架构和用户体验，从单一的资讯平台发展成为综合性的内容社区，获得了广大用户的认可。</p><h2>未来展望</h2><p>海角将继续投入技术研发，优化全球访问节点，提升服务质量，为用户提供更加稳定、快速、安全的访问体验。</p>",
    author: "海角官方",
    publishedAt: "2026-07-25",
    readTime: "4分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20tech%20aesthetic&width=400&height=250&seq=article-intro-01&orientation=landscape",
    heroImageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20modern%20abstract%20design%20with%20warm%20coral%20and%20golden%20accents%2C%20clean%20geometric%20shapes%2C%20soft%20gradient%20background%2C%20editorial%20style%2C%20professional%20corporate%20aesthetic&width=900&height=400&seq=article-hero-intro-01&orientation=landscape",
  },
];

export const faqs = [
  {
    question: "海角最新地址在哪里可以找到？",
    answer: "海角最新地址可以在本页面（海角最新地址·官方入口实时更新）找到。我们持续更新并维护最新的可用地址，包括主入口地址和备用地址。建议您将本页面加入浏览器收藏夹，以便随时获取最新地址信息。",
  },
  {
    question: "海角地址多久更新一次？",
    answer: "海角地址的更新频率并不固定，通常在平台进行服务器迁移、节点优化或出现访问异常时会发布新的地址更新。我们建议用户定期（每周至少一次）访问本页面查看是否有地址更新。",
  },
  {
    question: "海角地址失效了怎么办？",
    answer: "如果您发现海角地址无法访问，请按照以下步骤尝试：1）访问本页面查看是否已发布最新地址；2）使用本站提供的备用地址；3）清除浏览器缓存和 DNS 缓存后重试；4）尝试切换网络环境（如从移动数据切换至 Wi-Fi）。如果以上方法均无效，请联系客服获取帮助。",
  },
  {
    question: "如何确认地址是否为海角官方地址？",
    answer: "请以本页面公布的海角最新地址为准。本页面所有地址均经过海角官方认证，确保安全可靠。请不要轻信搜索引擎结果或社交媒体上传播的未经核实的地址，以防访问到钓鱼网站。",
  },
  {
    question: "海角备用地址有什么用？",
    answer: "海角备用地址是主入口地址的备用方案。当主地址因服务器维护、网络波动或其他原因暂时无法访问时，您可以使用备用地址继续访问海角平台。我们建议用户同时保存主地址和备用地址，以备不时之需。",
  },
  {
    question: "为什么不同地区的访问速度不一样？",
    answer: "海角在全球不同地区部署了多个服务器节点，不同节点之间的网络延迟会因地理位置和网络环境而有所不同。建议您选择标注为所在地区优化的地址入口（如亚洲用户选择亚洲专线），以获得更快的访问速度。",
  },
  {
    question: "手机端如何访问海角最新地址？",
    answer: "手机端访问海角最新地址的方法与电脑端类似：使用手机浏览器（推荐 Chrome 或 Safari）输入海角最新地址即可。建议使用 Wi-Fi 网络以获得更稳定的连接。如遇到访问问题，可尝试清除浏览器缓存后重试。",
  },
  {
    question: "访问海角地址需要 VPN 吗？",
    answer: "在大多数情况下，访问海角地址不需要使用 VPN。但如果您所在地区的网络限制较严格，或者当前地址在该地区解析异常，使用 VPN 或代理服务可能有助于解决访问问题。我们建议优先尝试直接访问，仅在必要时使用 VPN。",
  },
];

export const brandInfo = {
  name: "海角最新地址",
  slogan: "海角最新地址·官方入口实时更新",
  introduction: "海角最新地址是海角平台的官方地址发布与更新平台，致力于为广大用户提供最新、最稳定、最快速的海角访问入口。自成立以来，我们始终坚持实时更新、快速响应的服务理念，帮助用户解决地址失效问题，确保用户能够稳定访问海角平台。我们的地址覆盖全球多个区域节点，包括主入口、亚洲专线、欧洲节点以及多个备用地址，为用户提供全方位的访问保障。",
  reputation: [
    {
      content: "这个地址更新站点太方便了，再也不用担心打不开海角了。每次地址失效都能在这里找到新的，强烈推荐收藏！",
      author: "忠实用户 - 小明",
      date: "2026-08-06",
    },
    {
      content: "找了很久海角最新地址，终于在这个页面找到了。更新及时，地址稳定，访问速度也很快，五星好评！",
      author: "新用户 - 小红",
      date: "2026-08-05",
    },
    {
      content: "收藏了这个页面之后，再也没有遇到过无法访问的问题。备用地址也很实用，又一次主地址挂了就是靠备用地址续上的。",
      author: "老用户 - 阿强",
      date: "2026-08-04",
    },
    {
      content: "地址更新速度很快，基本上地址一失效这里就更新了新的。还提供了详细的访问教程，对小白用户非常友好。",
      author: "社区成员 - 小美",
      date: "2026-08-03",
    },
  ],
  contact: {
    email: "support@haijiao-official.com",
    wechat: "haijiao_official",
    qq: "1234567890",
  },
};